import { Action, ActionSubject, type UIEvent } from '../new-analytics-types';

export const tabEvents = {
  ui: {
    tabClicked: (attributes: { tabId: string }, source: string): UIEvent => ({
      data: {
        action: Action.Clicked,
        actionSubject: ActionSubject.NavigationItem,
        actionSubjectId: 'tabNavigation',
        source,
        attributes: {
          tabId: attributes.tabId,
        },
      },
      dataPortalLink: 'https://data-portal.internal.atlassian.com/analytics/registry/86700',
    }),
  },
};
